import { configureStore } from '@reduxjs/toolkit'
import estateReducer from './estateSlice'

export default configureStore({
    reducer: {
        properties: estateReducer
    }
})